/**
 * Collapsible Component
 *
 * A reusable collapsible component that handles toggling content visibility
 * with smooth animations and proper accessibility attributes.
 */

export default function initCollapsibles() {
  const collapsibles = document.querySelectorAll('[data-open-first]');

  collapsibles.forEach(collapsible => {
    const shouldOpenFirst = collapsible.getAttribute('data-open-first') === 'true';
    const items = collapsible.querySelectorAll('.collapsible-item');

    if (items.length === 0) return;

    // Function to close a collapsible
    function closeCollapsible(item) {
      item.classList.remove('active');
      const button = item.querySelector('.toggle-btn');
      const content = item.querySelector('[id^="content-"]');
      button.setAttribute('aria-expanded', 'false');

      // Reset style properties
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    }

    // Function to open a collapsible
    function openCollapsible(item) {
      item.classList.add('active');
      const button = item.querySelector('.toggle-btn');
      const content = item.querySelector('[id^="content-"]');
      const contentInner = content.querySelector('.content-inner');
      button.setAttribute('aria-expanded', 'true');

      // Get actual height of content for smooth animation
      const actualHeight = contentInner.offsetHeight;
      content.style.maxHeight = actualHeight + 'px';
      content.style.opacity = '1';
    }

    // Initialize all collapsibles
    items.forEach((item, index) => {
      // First ensure all are closed with proper initial styles
      const content = item.querySelector('[id^="content-"]');
      content.style.maxHeight = '0px';
      content.style.opacity = '0';

      // If this is the first item and should be open, open it
      if (index === 0 && shouldOpenFirst) {
        setTimeout(() => {
          openCollapsible(item);
        }, 10);
      }

      const header = item.querySelector('div:first-child');
      header.addEventListener('click', function() {
        const isCurrentlyActive = item.classList.contains('active');

        // Close all collapsibles
        items.forEach(otherItem => {
          if (otherItem.classList.contains('active')) {
            closeCollapsible(otherItem);
          }
        });

        // If the clicked item wasn't active, open it
        if (!isCurrentlyActive) {
          openCollapsible(item);
        }
      });
    });
  });
}
